import React from 'react';
import './PetAnimations.css';

export default function LanternImpSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#2A1E2C';
  const bodyLight = '#4A364C';
  const lanternGlow = '#FFB347';
  const lanternBright = '#FFE0A0';
  const metal = '#6E5236';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Warm lantern aura */}
      <circle cx="36" cy="64" r="34" fill={lanternGlow} opacity="0.18" />
      <circle cx="36" cy="64" r="22" fill={lanternBright} opacity="0.2" />
      {/* Body */}
      <ellipse cx="68" cy="74" rx="20" ry="22" fill={bodyColor} />
      {/* Belly highlight */}
      <ellipse cx="68" cy="78" rx="10" ry="14" fill={bodyLight} opacity="0.6" />
      {/* Devil tail */}
      <path d="M86 82C96 84 100 92 96 100C94 96 90 94 86 96" stroke={bodyColor} strokeWidth="3" strokeLinecap="round" fill="none" />
      <path d="M96 100L100 96L102 102L96 102Z" fill={bodyColor} />
      {/* Legs */}
      <rect x="58" y="90" width="7" height="12" rx="2" fill={bodyColor} />
      <rect x="71" y="90" width="7" height="12" rx="2" fill={bodyColor} />
      <ellipse cx="61.5" cy="102" rx="5" ry="2" fill={bodyLight} />
      <ellipse cx="74.5" cy="102" rx="5" ry="2" fill={bodyLight} />
      {/* Holding arm reaching toward lantern */}
      <path d="M54 70C46 70 40 68 36 64" stroke={bodyColor} strokeWidth="4.5" strokeLinecap="round" fill="none" />
      {/* Head */}
      <ellipse cx="68" cy="50" rx="18" ry="16" fill={bodyColor} />
      {/* Horns */}
      <path d="M56 38L52 26L60 36Z" fill={bodyColor} />
      <path d="M80 38L84 26L76 36Z" fill={bodyColor} />
      {/* Pointed ears */}
      <path d="M52 48L42 44L52 54Z" fill={bodyColor} />
      <path d="M84 48L94 44L84 54Z" fill={bodyColor} />
      {/* Eyes (glowing yellow) */}
      <ellipse cx="62" cy="50" rx="3" ry="3.5" fill={lanternBright} />
      <ellipse cx="74" cy="50" rx="3" ry="3.5" fill={lanternBright} />
      <ellipse cx="62" cy="50" rx="1.4" ry="2" fill="#2C2419" />
      <ellipse cx="74" cy="50" rx="1.4" ry="2" fill="#2C2419" />
      {/* Mischievous grin */}
      <path d="M62 58C65 62 71 62 74 58" stroke={lanternGlow} strokeWidth="1.2" strokeLinecap="round" fill="none" />
      <path d="M64 58L65 61M71 58L70 61" stroke="white" strokeWidth="0.8" strokeLinecap="round" />
      {/* Lantern */}
      <rect x="26" y="56" width="20" height="22" rx="2" fill={metal} />
      <rect x="28" y="58" width="16" height="18" rx="1" fill={lanternGlow} />
      <rect x="28" y="58" width="16" height="18" rx="1" fill={lanternBright} opacity="0.6" />
      {/* Lantern frame lines */}
      <line x1="36" y1="58" x2="36" y2="76" stroke={metal} strokeWidth="1" />
      <line x1="28" y1="67" x2="44" y2="67" stroke={metal} strokeWidth="0.8" />
      {/* Lantern top + handle */}
      <rect x="30" y="52" width="12" height="4" rx="1" fill={metal} />
      <path d="M30 52C30 46 42 46 42 52" stroke={metal} strokeWidth="1.5" fill="none" />
      {/* Lantern bottom cap */}
      <rect x="30" y="78" width="12" height="3" rx="1" fill={metal} />
      {/* Inner flame */}
      <ellipse cx="36" cy="68" rx="2.5" ry="4" fill="#FFF6CC" opacity="0.9" />
    </svg>
  );
}
